import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import './AllCurrentStaff.css'
import images1 from '../../assets/images1.jfif'
import { Button, Checkbox, Col, Dropdown, Menu, Radio, Row, Select, Table } from 'antd'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'
import FilterIcon from '../../assets/icons/filter-box.svg'
import SearchIcon from '../../assets/icons/search-box.svg'
import SettingIcon from '../../assets/icons/plus.svg'

import { AlignLeftOutlined, FilterOutlined, PlusOutlined, PrinterOutlined, SearchOutlined, SettingOutlined, UploadOutlined } from '@ant-design/icons'
import { BASE_URL, FetchDepartment, FetchDesignation, FetchLocation, FetchStaff, UpdateBulkStaff } from '../../utils/constant';
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from 'react-redux';
import ModalConfirm from '../../common/modalConfirm';
import { ExportToExcel } from '../../common/ExportToExcel';

const { Option } = Select;


function AllCurrentStaff({setCurrentstaff,onCurrentStaffClick}) {
    const gridApiRef = useRef(null);
    const gridRef = useRef();
    const designationState = useSelector((state) => state.designation.designation);
    const departmentState = useSelector((state) => state.department.department);
    const locationState = useSelector((state) => state.location.location);
    const [checkedIds, setCheckedIds] = useState([]);

    const [selectedColumn, setSelectedColumn] = useState(null);
    const [updateDataNames, setUpdateDataNames] = useState({});
    const [locationSelected, setLocationSelected] = useState();
    const [location, setLocation] = useState(locationState);
    const [designations, setDesignations] = useState(designationState && designationState.length > 0 ? designationState : []);
    const [departments, setDepartments] = useState(departmentState && departmentState.length > 0 ? departmentState : []);
    
    const [fullDepartment, setFullDepartment] = useState([]);
    const [subDepartmentList, setSubDepartmentList] = useState([]);
    const [departmentsSelected, setDepartmentsSelected] = useState(departmentState[0]?.key);
    const [visible, setVisible] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState({
        designation: [],
        department: [],
      });
    const handleVisibleChange = (flag) => {

      setVisible(flag);
    };
 
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [staffIds, setStaffIds] = useState([]);
    const [staffData, setStaffDetail] = useState([]);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [isAddColumnVisible, setIsAddColumnVisible] = useState(false);
    const [modalUpdateStaffVisible, setModalUpdateStaffVisible] = useState(false);
    const [updateStaffData, setUpdateStaffData] = useState(null);
    const [allStaffExportData, setAllStaffExportData]= useState([])

    const updateStaff = (params) => {
      setModalUpdateStaffVisible(true);
      setUpdateStaffData(params)      
    };
    const handleOk = (params) => {  
      if(params.key == 'deactivate'){

        deactiveBulk()     
      }else if(params.key == 'update'){
        handleMenuClick(params.event)
      }
      setModalUpdateStaffVisible(false);
    };
    const handleCancel = () => {
      setModalUpdateStaffVisible(false);
    };
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    //   const onGridReady = (params) => {
        //     gridApiRef.current = params.api;
        //   };
        const toggleSearchVisibility = () => {
            setIsSearchVisible(prevState => !prevState);
          };
        const toggleAddColumnVisibility = () => {
          setIsAddColumnVisible(prevState => !prevState);
          };
          const onFilterTextBoxChanged = useCallback(() => {
            gridRef.current.api.setGridOption(
              'quickFilterText',
              document.getElementById('filter-text-box').value
            );
          }, []);
        const gridOptions ={
       
            // onRowClicked: event => myFunction(event),
            suppressRowClickSelection: true,
            onCellClicked: (e) => {
                if (e.column.colId == 'name') { // cell is from non-select column
                  myFunction(e)
                }
            }
           } 
        
           const myFunction = (event,params) => {
            
                onCurrentStaffClick(event.data.item._id);
                setCurrentstaff('currentStaffDetail')
                const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};

            const stateToSave = {
              attendance:savedState.attendance,
              salesDepartmentId:'',
              currentStaffId:event.data.item._id,
              click : savedState.click,
              empClick:savedState.empClick,
              sales:'',
              currentStaff:'currentStaffDetail' ,
              active:savedState.active ,
              salesDepartmentId:'',
              params:params
            };
            sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
              
           }
        const staffIdsRef = useRef([]);

        const onGridReady = (params) => {
          gridApiRef.current = params.api;
          params.api.sizeColumnsToFit();
        };
      const onSelectionChanged = (e) => {

            // const selectedNodes = gridApiRef.current.getSelectedNodes();
            const selectedNodes = e.api.getSelectedRows();
            const selectedData = selectedNodes.map((node) => node?.item?._id);
            // checkedIds = selectedData;
        
        };
        
        const deactiveBulk = () => {
             if(checkedIds.length > 0){
                updateStaffList({isActive : false})
             }else{
                toast.error('Please select staff to update', {
                    position: toast.POSITION.TOP_RIGHT,
                  });
             }
        }
        const checkIdsRef = useRef([])
        const handleCheckboxChange = (item, isChecked) => {
            if (isChecked) {
              checkIdsRef.current =  [...checkIdsRef.current, item._id];
            } else {
              checkIdsRef.current =  checkIdsRef.current.filter(id => id !== item._id);
            }
            setCheckedIds(checkIdsRef.current)
        };
        
      const [columnsStaff, setColumns] = useState([
        {
          headerName: '',
          field:'Add',
          width: 50,
          cellRenderer: (params) => {
              return(
              <>
              {params?.data.item?.isStaffBo !== true &&
              <Checkbox
              checked={checkIdsRef.current.includes(params.data.item._id)}
              onChange={(e) => handleCheckboxChange(params?.data?.item, e.target.checked)}>
              </Checkbox>
              }
            {/* <input value="test" type="checkbox" onChange={handleChange} />  */}
  
                </>
          )
              }
        },
        // {
        //     headerCheckboxSelection: true,
        //     checkboxSelection: true,
        //     headerName: 'Select All',
        //     field: 'select',
        //     width: 50,
        //     suppressToolPanel: true,
        //   },
        {
          headerName: ' Name',
          field: 'name',
          flex: 1     ,    
          cellRenderer: (params) => {
            return(
            <>
          <div className='flex items-center'>
            <img
              className='w-[30px] h-[30px] rounded-full !mr-3'
              src={params.data.item.faceRegisterUrl}
              alt=''
            />
            <p>{capitalizeFirstLetter(params.data.item?.firstName)} {capitalizeFirstLetter(params.data.item?.lastName)}</p>
          </div>
          </>
            )
            },
        },
        {
          headerName: 'Shift',
          field: 'shift',
          flex: 1
        },
        {
          headerName: 'Location',
          field: 'location',
          flex: 1
        },
        {
          headerName: 'Gender',
          field: 'gender',
          flex: 1
        },
        {
          headerName: 'Permanent Address',
          field: 'permanentAddress',
          flex: 1
        },
        {
          headerName: 'Current Address',
          field: 'currentAddress',
          flex: 1 
        },
        // {
        //   headerName: '+',
        //   field: '',
        // },
        
      ]);
      const [selectedColumns, setSelectedColumns] = useState(['Add','select','name','shift', 'location']);

     
      const dropdownOptions = columnsStaff.slice(0);

      const dataStaff = staffData.map((item, index) => {
        return {
        key: index,
        item:item,
        addContractors:item,
        name: `${capitalizeFirstLetter(item?.firstName)} ${capitalizeFirstLetter(item?.lastName)}`,
        shift: capitalizeFirstLetter(item?.shift?.shiftFullName),
        location: capitalizeFirstLetter(item?.mainSite[0]?.locationName1),
        gender: capitalizeFirstLetter(item?.gender),
        permanentAddress: capitalizeFirstLetter(item?.permanentAddress),
        currentAddress: capitalizeFirstLetter(item?.currentAddress),
       
        }
      
      });
    
      const handleMenuClick = (e) => {
        if(e.keyPath[1] == "designation"){
          if(checkedIds.length > 0){
            updateStaffList({designation : e.keyPath[0]})
         }else{
            toast.error('Please select staff to update', {
                position: toast.POSITION.TOP_RIGHT,
              });
         }
        } else if(e.keyPath[1] == "department"){
            const selectedDepartment = departments.find((dept) => dept.departmentId === e.keyPath[1]);
            // Update subDepartmentList based on the selected department
            if (selectedDepartment && selectedDepartment.subDepartments) {
              const subDepartments = selectedDepartment.subDepartments?.map((subDept) => ({
                key: subDept.subDeptId,
                value: subDept.subDeptName,
              }));
              setSubDepartmentList(subDepartments);
            } else {
              // If no subDepartments found, set subDepartmentList as empty array
              setSubDepartmentList([]);
            }
            if(checkedIds.length > 0){
              updateStaffList({department : e.keyPath[0]})
           }else{
              toast.error('Please select staff to update', {
                  position: toast.POSITION.TOP_RIGHT,
                });
           }
        } else if(e.keyPath[1] == "subDepartmentId"){
          if(checkedIds.length > 0){
            updateStaffList({subDepartmentId : e.keyPath[0]})
         }else{
            toast.error('Please select staff to update', {
                position: toast.POSITION.TOP_RIGHT,
              });
         }
        } else if(e.keyPath[1] == "designation"){
          if(checkedIds.length > 0){
            updateStaffList({designation : e.keyPath[0]})
         }else{
            toast.error('Please select staff to update', {
                position: toast.POSITION.TOP_RIGHT,
              });
         }
      }
       
      };

      const menu = (
        <Menu onClick={(e) => updateStaff({key : 'update',event:e })}>
          <Menu.SubMenu key="department" title="Department">
            {departments && departments.length > 0 && departments?.map((department) => (
              <Menu.Item key={department.key}>{department.value}</Menu.Item>
            ))}
          </Menu.SubMenu>
         
          <Menu.SubMenu key="designation" title="Designation">
            {designations && designations.length > 0 && designations.map((designation) => (
              <Menu.Item key={designation.key}>{designation.value}</Menu.Item>
            ))}
          </Menu.SubMenu>
        </Menu>
      );
  
      const getStaffList = async () =>{
        const filtersToSend = Object.fromEntries(
            Object.entries(selectedFilters).filter(([_, value]) => value.length > 0)
        );
        const token = localStorage.getItem('authToken');
        console.log("====filtersToSend===>", filtersToSend)
        try{
           
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({...filtersToSend,isActive:true}),
              });
              
              if (response.ok) {
                const data = await response.json();
                // const activeStaff = data.data.filter(item => item.isActive);
                // console.log('activeStaff',activeStaff)
               setStaffDetail(data?.data)
               const transformedData = data?.data?.map(item => ({
                 Name: `${item.firstName} ${item.lastName}`,
                 StaffNumber: item?.staffNumber,
                 Shift: item?.shift?.shiftFullName,
                 Location : item?.mainSite?.map(data => data?.locationName2).join(', '),
                 Department : item?.department?.departmentName,
                 Designation : item?.designation?.designationName
               }))
               setAllStaffExportData(transformedData)
              } else {
                const data = await response.json();
                console.log('stafferr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const getDepartmentList = async () =>{
        const token = localStorage.getItem('authToken');
      
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeDepartment = data?.data?.filter(item => item.isActive);
                setFullDepartment(activeDepartment)
                const newArray = activeDepartment.map((item) => ({
                    value: item.departmentName,
                    key: item.departmentId
                  }));
                  if(newArray.length > 0){

                      setDepartmentsSelected(newArray[0].key)
                    }

                 setDepartments(newArray)
                //  getStaffList()
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
               
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const getDesignationList = async () =>{
        const token = localStorage.getItem('authToken');
      
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeDesignation = data.data.filter(item => item.isActive);
                const newArray = activeDesignation.map((item) => ({
                    value: item.designationName,
                    key: item.designationId
                  }));
                 setDesignations(newArray)
              
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const getLocationList = async () =>{
        const token = localStorage.getItem('authToken');
      
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchLocation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocation = data.data.filter(item => item.isActive);
                const newArray = activeLocation.map((item) => ({
                    value: item.locationName1,
                    key: item.locationId
                  }));
                 setLocation(newArray)
              
              } else {
                const data = await response.json();
                console.log('locationerr',data)
               
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const updateStaffList = async (updatevalues) =>{
        const token = localStorage.getItem('authToken');
        const updatedData = {
            staffIds : checkedIds,
            updateData : updatevalues
        }
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${UpdateBulkStaff}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify(updatedData),
              });
              
              if (response.ok) {
                const data = await response.json();
                setCheckedIds([])
                checkIdsRef.current= []
                getStaffList()
                toast.success('Staff Successfully Updated', {
                    position: toast.POSITION.TOP_RIGHT,
                  });
              } else {
                const data = await response.json();
                console.log('stafferr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating StaffList:', error);
        }
      }
      const handleLocationMenuClick = (e) => {
        setLocationSelected(e.key);
      }
      const handleDeptMenuClick = (e) => {
        setDepartmentsSelected(e.key);
      };
      useEffect(() => {
        getStaffList();
      }, [selectedFilters,locationSelected,departmentsSelected]);
      const dept = (
        <Menu onClick={handleDeptMenuClick}>
          
            {departments && departments.length > 0 && departments?.map((department) => (
              <Menu.Item key={department.key}>{department.value}</Menu.Item>
            ))}
        </Menu>
      );
      const locationMenu = (
        <Menu onClick={handleLocationMenuClick}>
          
            {location && location.length > 0 && location.map((location) => (
              <Menu.Item key={location.key}>{location.value}</Menu.Item>
            ))}
        </Menu>
      );
     
      const filters = {
        designation: designations,
        department: departments,
      };
    
      const handleFilterMenuClick = (type, { key }) => {
        const updatedSelection = selectedFilters[type].includes(key)
          ? selectedFilters[type].filter((item) => item !== key)
          : [...selectedFilters[type], key];
        setSelectedFilters({ ...selectedFilters, [type]: updatedSelection });
      };
    
    const filterMenu = (type) => (
        <Menu onClick={(item) => handleFilterMenuClick(type, item)}>
          {filters[type]?.map((filter) => (
            <Menu.Item key={filter.key}>
              <Checkbox className='mr-1' checked={selectedFilters[type]?.includes(filter.key)}/>
                {filter.value}
            </Menu.Item>
          ))}
        </Menu>
      );
    const dropdownMenu = (
        <Menu>
          <Menu.SubMenu key="designation" title="Designation">
            {filterMenu("designation")}
          </Menu.SubMenu>
          <Menu.SubMenu key="department" title="Department">
            {filterMenu("department")}
          </Menu.SubMenu>
        </Menu>
      );
    
  
    const onDropdownChange = (values) => {
        setSelectedColumns(values);
      };
   
    return (
        <div className='p-2'>
                 <ToastContainer position="top-right" autoClose={2000} />

            <div className='flex flex-wrap'>
                <div className='mr-1'>
                    <div className='bg-[#E9F1FD] rounded-[14px] p-3'>
                      <div className='flex items-center'>
                          <div className='text-[#4B8AEB] text-center'>
                              <p className='text-3xl font-bold leading-7'>{staffData[0]?.totalStaff}</p>
                              <p className='text-xs font-sbold'>Total records</p>
                          </div>
                          <div sm={12} className='border-left pl-2 ml-2 py-1'>
                              <p className='text-xs'>Activated: {staffData[0]?.activeStaff}</p>
                              <p className='text-xs'>Deactivated: {staffData[0]?.inActiveStaff}</p>
                          </div>
                      </div>
                    </div>
                </div>
         
            </div>
            <Row className='mt-3'>
                <Col sm={16}>
                    <div className='flex justify-between'>
                        <div>
                            {/* <PrinterOutlined className='allstaff-icon' /> */}
                            <span className='h-[35px] text-sm border !border-[#00305F] px-6 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all text-[#00305F]' 
                            onClick={() => updateStaff({key : 'deactivate'})}>Deactivate</span>
                            <Dropdown className='!ml-2' overlay={menu} trigger={['click']}>                               
                              <span className='h-[35px] text-sm border !border-[#00305F] px-6 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all text-[#00305F]'>Bulk Changes</span>
                            </Dropdown>
                        </div>
                        <div className='d-inline-flex align-items-center'>
                     
                              {isAddColumnVisible && ( <Select
                              open={true}
                                mode="multiple"
                                style={{ marginRight:'10px' }}
                                placeholder="Select columns"
                                onChange={onDropdownChange}
                                value={selectedColumns}
                                maxTagCount={1}
                              >
                                {dropdownOptions.map((column) => (
                                  <Option key={column.field} value={column.field}>
                                    {column.headerName}
                                  </Option>
                                ))}
                              </Select>
                              )}
                            <img src={SettingIcon} onClick={toggleAddColumnVisibility} className='mr-2 cursor-pointer'/>

                            {/* </div> */}
                            {isSearchVisible && (
                              <input
                                type="text"
                                className='border-bottom h-[39px] !border-[#B7D0F7] outline-none'
                                style={{width:'8rem'}}
                                id="filter-text-box"
                                placeholder="Search..."
                                onInput={onFilterTextBoxChanged}
                              />
                            )}
                            <img src={SearchIcon} onClick={toggleSearchVisibility} className='mr-2 cursor-pointer'/>
                            {/* <FilterOutlined className='allstaff-icon mr-1' /> */}
                            <Dropdown className='mr-2' overlay={dropdownMenu} trigger={["click"]} placement="bottom">
                              {/* <Button className="btn filterBtn">Filter</Button> */}
                              <img src={FilterIcon} className='cursor-pointer'/>
                            </Dropdown>
                            {staffData.length > 0 &&
                            <ExportToExcel additionalClass={""} apiData={allStaffExportData} fileName={"AllStaffData"} />
                            }
                            {/* <AlignLeftOutlined className='allstaff-icon mr-1' />
                            <UploadOutlined className='allstaff-icon mr-3' />
                            <SettingOutlined className='history-icon' /> */}
                        </div>
                    </div>
                      {/* <p className='to-sale-dep'>{capitalizeFirstLetter(staffData[0]?.department?.departmentName)} Department</p> */}
                    <div className='ag-theme-alpine text-base border-none font-proxima' style={{ height: 'auto', width: '100%', marginTop: '10px' }}>
                          <AgGridReact
                            // columnDefs={columnsStaff}
                            // columnDefs={columnsStaff.filter((column) => columnState[column.field])}
                            columnDefs={columnsStaff.filter((column) => selectedColumns.includes(column.field))}
                            // onRowClicked={(e) => console.log('Row clicked',e)}

                            gridOptions={gridOptions}
                            rowData={dataStaff}
                            rowSelection={'multiple'}
                            rowMultiSelectWithClick={true}
                            checkboxSelection={true}
                            domLayout='autoHeight'
                            pagination={true}
                            onGridReady={onGridReady}
                            onSelectionChanged={onSelectionChanged}
                            paginationPageSize={20}
                            getRowHeight={() => 60}
                            suppressRowClickSelection={true} 
                            ref={gridRef}
                            paginationPageSizeSelector={false}
                          />
                    </div>
                  
                </Col>
            </Row>
            <ModalConfirm
        visible={modalUpdateStaffVisible}
        onOk={() => handleOk(updateStaffData)}
        onCancel={handleCancel}
        title="Update"
        content="Are you sure you want to Update?"
      />
           
        </div>
    )
}

export default React.memo(AllCurrentStaff)



